@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Pended Timesheets</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    @if(processCodes && processCodes.length) {
                    <ppl-timesheet-filter [filterFields]="fields" (searchEvent)="onSearch($event)"
                        [processCodes]="processCodes" [pageId]="pageId"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1">*</span> Atleast one out of the following fields
                        should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.</p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Deny</strong> and <strong>Override</strong> actions, please select the
                                applicable timesheets.</li>
                            <li>The <strong>Deny All</strong> and <strong>Override All</strong> actions will update all
                                timesheets that match the search criteria.</li>
                            <li>The <strong>Reprocess</strong> action applies to the selected Denied or Ready for
                                Payment timesheets that have not been sent to NAV.</li>
                        </ul>
                    </div>
                    }
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true"
                        [enableActions]="false" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" (onPageLoad)="onPageLoad($event)"
                        [actionButtons]="actionButtons" (rowDetailEvent)="rowClicked($event)" [enablePageActions]="!isReadOnly"
                         [badgeColumns]="['Application Status']"
                        [listButton]="isReadOnly ? [] : buttons" [timesheetFor]="'pendedTimesheet'" (actionInvoked)="gridAction($event)" [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #pendedDialog let-cancel="cancel">
        <ppl-timesheet-staff-errorcode [errorcodeData]="errorcodeData" (onSaveComplete)="onSaveAdjustment($event)"
            [disabled]="isReadOnly || disableEditingPendedTimesheet"></ppl-timesheet-staff-errorcode>
    </ng-template>
</div>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [isOkText]="okText" (confirm)="handleOk()"
    (cancel)="handleCancel()" [showButtons]="true" [showOkButton]="false" [size]="'medium'" [position]="'center'">

    <form nz-form [formGroup]="timesheetActionForm">
        @if(noProcessCodeToOverrideMessage) {
            <div class="w-100 alert alert-warning d-flex justify-content-between align-items-center">
                <span>{{noProcessCodeToOverrideMessage}}</span>
            </div>
        }
        <!-- Selected Process Code Field -->
        <div nz-row>
            <div nz-col *ngIf="timesheetActionForm.controls['selectedProcessCode']"
                style="margin-left: 8px; margin-right: 8px;width: 100%;">
                <nz-form-item>
                    <nz-form-control>
                        <nz-select [nzMode]="'multiple'" formControlName="selectedProcessCode" class="filters"
                            id="selectedProcessCode" nzPlaceHolder="Select Process Code" nzShowSearch
                            style="width: 100%;"
                            [nzStatus]="timesheetActionForm.get('selectedProcessCode')?.invalid && timesheetActionForm.get('selectedProcessCode')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of allowedProcessCodes" [nzLabel]="opt.displayName"
                                [nzValue]="opt.code">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
            *ngIf="timesheetActionForm.get('selectedProcessCode')?.invalid && timesheetActionForm.get('selectedProcessCode')?.touched">
            <div class="error-message">Please select a process code.</div>
        </div>

        <!-- Reason Field -->
        <div nz-row>
            <div nz-col *ngIf="timesheetActionForm.controls['reason']"
                style="margin-left: 8px; margin-right: 8px;width: 100%;">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="'Please select a reason'">
                        <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason"
                            nzShowSearch style="width: 100%;"
                            [nzStatus]="timesheetActionForm.get('reason')?.invalid && timesheetActionForm.get('reason')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of reasonList" [nzLabel]="opt.lkpValueName"
                                [nzValue]="opt.lkpValueCode">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>

                </nz-form-item>
            </div>
        </div>

        <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
            *ngIf="timesheetActionForm.get('reason')?.invalid && timesheetActionForm.get('reason')?.touched">
            <div class="error-message">Please select a reason.</div>
        </div>

        <!-- Comments Field -->
        <div nz-row>
            <div nz-col *ngIf="timesheetActionForm.controls['comments']"
                style="margin-left: 8px; margin-right: 8px; width: 100%;">
                <nz-form-item>
                    <nz-form-control [nzErrorTip]="'Please select a reason'">
                        <label for="comments" class="field-header">Comments</label>
                        <nz-textarea-count [nzMaxCharacterCount]="10000">
                            <textarea rows="3" nz-input id="comments" formControlName="comments"
                                placeholder="Start typing..." [maxlength]="10000"
                                [nzStatus]="timesheetActionForm.get('comments')?.invalid && timesheetActionForm.get('comments')?.touched ? 'error' : ''"></textarea>
                        </nz-textarea-count>
                        <div
                            *ngIf="timesheetActionForm.get('comments')?.invalid && timesheetActionForm.get('comments')?.touched">
                            <div class="error-message">Please enter a message.</div>
                        </div>
                    </nz-form-control> </nz-form-item>
            </div>
        </div>
    </form>

</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> This action will apply to all timesheets that meet the search criteria. Do you want to continue?</p>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #warningDialog let-cancel="cancel">
        <p> Atleast one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>

<ppl-correction-notes-dialog [(visible)]="showReprocessPopup" title="Reprocess" okText="Reprocess"
    [message]="reprocessIds.length + ' selected timesheet(s) will be reprocessed. Timesheets already sent to NAV will not be reprocessed.'"
    placeholder="Reason for reprocessing" (confirmed)="submitReprocess($event)">
</ppl-correction-notes-dialog>
